import {Component, Input} from '@angular/core';
import {Activiteit} from '../activiteit';
import {Client} from '../../client/client';
import User from '../../core/auth/user';
import {Zone} from '../../zone/zone';

@Component({
    selector: 'zah-activiteit-list-item',
    templateUrl: './activiteit-list-item.component.html',
    styleUrls: ['./activiteit-list-item.component.scss'],
    standalone: false
})
export class ActiviteitListItemComponent {

  @Input()
  activiteit: Activiteit;
  @Input()
  client: Client;
  @Input()
  auteur: User;
  @Input()
  zones: Array<Zone>;
}
